import React from 'react';
import Svg, { Path } from 'react-native-svg';
import { IconProps } from 'shared/components/vxl/icon/Icon/Icon';

export default function Clock({
  iconColor,
  iconSize,
  iconAccessibilityLabel,
}: IconProps) {
  return (
    <Svg
      accessibilityLabel={iconAccessibilityLabel}
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
    >
      <Path
        d="M11.9999 2.66659C6.84526 2.66659 2.66659 6.84526 2.66659 11.9999C2.66659 17.1546 6.84526 21.3333 11.9999 21.3333C17.1546 21.3333 21.3333 17.1546 21.3333 11.9999C21.3333 6.84526 17.1546 2.66659 11.9999 2.66659ZM1.33325 11.9999C1.33325 6.10888 6.10888 1.33325 11.9999 1.33325C17.891 1.33325 22.6666 6.10888 22.6666 11.9999C22.6666 17.891 17.891 22.6666 11.9999 22.6666C6.10888 22.6666 1.33325 17.891 1.33325 11.9999Z"
        fill={iconColor}
      />
      <Path
        d="M10.6666 4.99992H11.9999V11.9999H16.9999V13.3333H10.6666V4.99992Z"
        fill={iconColor}
      />
    </Svg>
  );
}
